import debounce from 'lodash/debounce';
import handleDefaultInit from './handleDefaultInit';
import handleUnloadableInit from './handleUnloadableInit';

/**
 * Attach interactions to every element that matches selector.
 */
$('[data-itemSlider]').each((_, component) => {
    const type = $(component).attr('data-itemSlider');

    const handleInit = handleDefaultInit;

    if (type === 'unload') {
        const unloadWidth = $(component).attr('data-unloadWidth');
        $(window).on('load resize orientationchange', debounce(handleUnloadableInit(component, unloadWidth)));
    } else {
        $(window).on('load', handleInit(component));
    }
});



// WEBPACK FOOTER //
// ./src/scripts/components/item-slider/index.js